import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { forwardRef as l, useCallback as d } from "react";
import h from "classnames";
import r from "./index.es5491.js";
import { ChipDecoration as x } from "./index.es5492.js";
const C = l(
  ({ label: t, ColorIndicator: a, LeftIcon: m, size: i, onClick: o }, n) => {
    const s = !!o, p = d(
      (c) => {
        c.stopPropagation(), o == null || o(t);
      },
      [t, o]
    );
    return /* @__PURE__ */ f(
      "div",
      {
        ref: n,
        className: h(r.content, { [r.clickable]: s }),
        onClick: s ? p : void 0,
        children: [
          /* @__PURE__ */ e(x, { ColorIndicator: a, LeftIcon: m, size: i }),
          /* @__PURE__ */ e("span", { className: r.label, children: t })
        ]
      }
    );
  }
);
export {
  C as ChipContent
};
//# sourceMappingURL=index.es714.js.map
